import { useState } from 'react';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';

// eslint-disable-next-line import/prefer-default-export
export const useValidateSmiles = () => {
  const [error, setError] = useState(undefined);
  const [validSmiles, setValidSmiles] = useState(undefined);
  const [isLoading, setIsLoading] = useState(undefined);

  const validate = async (smilesToValidate) => {
    try {
      setIsLoading(true);
      await MessageBroker.send(
        RequestUrls.validateSmiles,
        { structures: smilesToValidate.map((smiles) => smiles.value) },
        {
          ignoreIntercepts: true,
        }
      );
      setIsLoading(false);
      setError(null);
      setValidSmiles(smilesToValidate);
    } catch (e) {
      setError(e.message);
      setIsLoading(false);
      setValidSmiles(null);
    }
  };

  return { validate, validSmiles, error, isLoading };
};
